import { Link } from 'react-router-dom';

import React from 'react';

export default function CarsAgentsShowroom() {
	return (
		<div>
			<div class='sp-banner'>
				<img
					src='assets/images/service-provider/cars-agents/banner.jpg'
					alt=''
					class='img-fluid sp-banner-img'
				/>
				<div class='sp-logo'>
					<div class='line-a'>
						<img
							src='assets/images/car-brands/mercedes-benz.jpg'
							alt=''
							class='img-fluid'
						/>
					</div>
					<div class='line-b'>Mercedes Benz</div>
				</div>
			</div>

			<div class='main-content-area'>
				<div class='container'>
					<div class='row justify-content-between'>
						<div class='col-12 col-sm-12 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0'>
							<div class='side-package'>
								<div class='line-a'>PACKAGE</div>
								<div class='line-b'>
									<div class='side-package-progress'>
										<span class='eighty'></span>
									</div>
								</div>
								<div class='line-c'>30 days remaining</div>
								<div class='line-d'>Validity till 02 March 2021</div>
								<div class='line-e'>
									<a class='btn btn-dark btn-sm' href='#' role='button'>
										UPDATE
									</a>
								</div>
							</div>

							<div class='side-links-wrap'>
								<ul>
									<li>
										<Link to='/sp-cars-agents-business'>
											<img
												src='assets/images/icons/sp-business/manage-business.svg'
												alt=''
											/>{' '}
											Manage Business
										</Link>
									</li>
									<li>
										<Link to='/sp-cars-agents-categories'>
											<img
												src='assets/images/icons/sp-business/manage-service.svg'
												alt=''
											/>{' '}
											Manage Categories
										</Link>
									</li>
									<li>
										<Link to='/sp-cars-agents-cars'>
											<img
												src='assets/images/icons/sp-business/manage-service.svg'
												alt=''
											/>{' '}
											Manage Cars
										</Link>
									</li>
									<li>
										<Link to='/sp-cars-agents-banner'>
											<img
												src='assets/images/icons/sp-business/banner.svg'
												alt=''
											/>{' '}
											Banner
										</Link>
									</li>
									<li>
										<Link to='/sp-cars-agents-working-hours'>
											<img
												src='assets/images/icons/sp-business/manage-working-hours.svg'
												alt=''
											/>{' '}
											Manage Working Hours
										</Link>
									</li>
									<li>
										<Link to='/sp-cars-agents-showroom' class='active'>
											<img
												src='assets/images/service-icons/garage.svg'
												alt=''
											/>{' '}
											Manage Showroom
										</Link>
									</li>
									<li>
										<Link to='/sp-cars-agents-workshop'>
											<img
												src='assets/images/service-icons/car-wash.svg'
												alt=''
											/>{' '}
											Manage Workshop
										</Link>
									</li>
								</ul>
							</div>
						</div>

						<div class='col-12 col-sm-12 col-md-9 col-lg-9'>
							<div class='row mb-4 align-items-center justify-content-between'>
								<div class='col'>
									<h3 class='mb-0'>Manage Showroom</h3>
								</div>
								<div class='col-auto'>
									<a
										class='btn btn-outline-secondary'
										href='sp-cars-agents-manage-cars-add.html'
										data-toggle='modal'
										data-target='#showroom'>
										+ Add Showroom
									</a>
								</div>
							</div>

							<ul class='unstyled store-list anim4'>
								<li>
									<div class='store-radio'>
										<input
											class='styled-checkbox'
											id='Store1'
											name='store'
											type='radio'
											value='Salmiya'
										/>
										<label for='Store1'></label>
									</div>
									<h3>Salmiya</h3>
									<p class='address-text'>
										Bldg. 116, Block 2, Salem Al Mubarak St., 5th Floor, Opp.
										Olympia Towers, Salmiya, Kuwait.
									</p>
									<div class='store-footer'>
										<div class='store-openclose opennow'>Open Now</div>
										<div class='store-time store-time-show-work'>
											Will close at 4:30 PM
										</div>
										<div class='line-d line-edit-delete'>
											<div class='row'>
												<div class='col-auto'>
													<Link to='sp-air-conditioning-manage-working-hours.html'>
														<i class='far fa-clock'></i> Manage Hours
													</Link>
												</div>
												<div class='col-auto'>
													<Link
														to='javascript:void(0)'
														data-toggle='modal'
														data-target='#showroom'>
														<i class='far fa-edit'></i> Edit
													</Link>
												</div>
												<div class='col-auto'>
													<Link to='javascript:void(0)'>
														<i class='far fa-trash-alt'></i> Delete
													</Link>
												</div>
											</div>
										</div>
									</div>
								</li>
								<li>
									<div class='store-radio'>
										<input
											class='styled-checkbox'
											id='Store2'
											name='store'
											type='radio'
											value='Kuwait City'
										/>
										<label for='Store2'></label>
									</div>
									<h3>Kuwait City</h3>
									<p class='address-text'>
										Bldg. 116, Block 2, Salem Al Mubarak St., 5th Floor, Opp.
										Olympia Towers, Salmiya, Kuwait.
									</p>
									<div class='store-footer'>
										<div class='store-openclose closenow'>Closed</div>
										<div class='store-time store-time-show-work'>
											Will close at 4:30 PM
										</div>
										<div class='line-d line-edit-delete'>
											<div class='row'>
												<div class='col-auto'>
													<Link to='sp-air-conditioning-manage-working-hours.html'>
														<i class='far fa-clock'></i> Manage Hours
													</Link>
												</div>
												<div class='col-auto'>
													<Link
														to='javascript:void(0)'
														data-toggle='modal'
														data-target='#showroom'>
														<i class='far fa-edit'></i> Edit
													</Link>
												</div>
												<div class='col-auto'>
													<Link to='javascript:void(0)'>
														<i class='far fa-trash-alt'></i> Delete
													</Link>
												</div>
											</div>
										</div>
									</div>
								</li>
								<li>
									<div class='store-radio'>
										<input
											class='styled-checkbox'
											id='Store3'
											name='store'
											type='radio'
											value='Al Farwaniyah'
										/>
										<label for='Store3'></label>
									</div>
									<h3>Al Farwaniyah</h3>
									<p class='address-text'>
										Bldg. 116, Block 2, Salem Al Mubarak St., 5th Floor, Opp.
										Olympia Towers, Salmiya, Kuwait.
									</p>
									<div class='store-footer'>
										<div class='store-openclose opennow'>Open Now</div>
										<div class='store-time store-time-show-work'>
											Will close at 4:30 PM
										</div>
										<div class='line-d line-edit-delete'>
											<div class='row'>
												<div class='col-auto'>
													<Link to='sp-air-conditioning-manage-working-hours.html'>
														<i class='far fa-clock'></i> Manage Hours
													</Link>
												</div>
												<div class='col-auto'>
													<Link
														to='javascript:void(0)'
														data-toggle='modal'
														data-target='#showroom'>
														<i class='far fa-edit'></i> Edit
													</Link>
												</div>
												<div class='col-auto'>
													<Link to='javascript:void(0)'>
														<i class='far fa-trash-alt'></i> Delete
													</Link>
												</div>
											</div>
										</div>
									</div>
								</li>
								<li>
									<div class='store-radio'>
										<input
											class='styled-checkbox'
											id='Store4'
											name='store'
											type='radio'
											value='Hawally'
										/>
										<label for='Store4'></label>
									</div>
									<h3>Hawally</h3>
									<p class='address-text'>
										Bldg. 116, Block 2, Salem Al Mubarak St., 5th Floor, Opp.
										Olympia Towers, Salmiya, Kuwait.
									</p>
									<div class='store-footer'>
										<div class='store-openclose closenow'>Closed</div>
										<div class='store-time store-time-show-work'>
											Will close at 4:30 PM
										</div>
										<div class='line-d line-edit-delete'>
											<div class='row'>
												<div class='col-auto'>
													<Link to='sp-air-conditioning-manage-working-hours.html'>
														<i class='far fa-clock'></i> Manage Hours
													</Link>
												</div>
												<div class='col-auto'>
													<Link
														to='javascript:void(0)'
														data-toggle='modal'
														data-target='#showroom'>
														<i class='far fa-edit'></i> Edit
													</Link>
												</div>
												<div class='col-auto'>
													<Link to='javascript:void(0)'>
														<i class='far fa-trash-alt'></i> Delete
													</Link>
												</div>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
